import { StagePosition } from "./types";

export const calculateNewStageOrder = <T extends { id: string | number }>(
  currentStages: T[],
  stageId: T["id"],
  positionInPipeline: string
): Array<T["id"]> => {
  const isExistingStage = currentStages.some((stage) => stage.id === stageId);

  const newOrder: Array<T["id"]> = currentStages
    .map((stage) => stage.id)
    .filter((id) => !isExistingStage || id !== stageId);

  const addAtEnd = () => [...newOrder, stageId];

  if (positionInPipeline === StagePosition.FIRST) {
    if (newOrder.length === 0) return addAtEnd();
    newOrder.unshift(stageId);
    return newOrder;
  }

  if (positionInPipeline === StagePosition.LAST) {
    if (newOrder.length === 0) return addAtEnd();
    newOrder.push(stageId);
    return newOrder;
  }

  if (positionInPipeline.startsWith(StagePosition.AFTER_PREFIX)) {
    const targetStageIdRaw = positionInPipeline.replace(
      StagePosition.AFTER_PREFIX,
      ""
    );
    const targetStageIndex = newOrder.findIndex(
      (id) => String(id) === targetStageIdRaw
    );

    if (targetStageIndex === -1) return addAtEnd();

    newOrder.splice(targetStageIndex + 1, 0, stageId);
    return newOrder;
  }

  return addAtEnd();
};
